module.exports = __webpack_public_path__ + "static/media/game-board.f3324aa2.svg";